import { useState } from 'react';
import CustomTextAreaInput from '../../InputFields/CustomTextAreaInput';

const ReadOnlyTextAreaType = ({
  onDataChange,
  defaultValue,
}: {
  onDataChange: (updatedValues: { [key: string]: string }) => void;
  defaultValue: string;
}) => {
  const [formData, setFormData] = useState({
    defaultValue: defaultValue || '',
  });

  const handleInputChange = (e: any) => {
    const { name, value } = e.target;
    const updatedFormData = { ...formData, [name]: value };

    setFormData(updatedFormData);

    onDataChange({ [name]: value });
  };

  return (
    <div className="ml-4">
      <CustomTextAreaInput
        label="Default Value"
        name="defaultValue"
        value={formData.defaultValue}
        onChange={handleInputChange}
        placeholder="Enter the description. i.e - This section provides key points of contact for communication and support."
        description="This will help in guiding the person filling this field."
        rows={12}
      />
    </div>
  );
};

export default ReadOnlyTextAreaType;
